import logo from '@/assets/logos/tis.png';
import type { INamespaceConfig } from '../types';

export const tisConfig: INamespaceConfig = {
  namespace: 'tis',
  branding: {
    logoSrc: logo,
    logoAlt: 'TIS',
    logoWidth: 300,
    companyName: 'TIS',
    appName: 'Customer Portal',
    faviconHref: '/favicon-tis-150x150.png',
  },
  theme: {
    colorPrimary: '#1B1E4D',
    colorSecondary: '#7874B6',
    colorAccent: '#AF557E',
    colorHighlight: '#1DB4D8',
    colorMuted: '#6E6A8D',
    colorLight: '#6BC6E4',
  },
  contact: {
    phone: '1-800-563-0314',
    phoneHref: 'tel:1-800-563-0314',
    internationalPhone: '514-375-8234',
    internationalPhoneHref: 'tel:514-375-8234',
    email: 'info@tis.ca',
    claimsEmail: 'claims@tis.ca',
    legalAssistanceEmail: '',
    website: 'https://tis.ca',
  },
  features: {
    claims: true,
    faq: true,
  },
  socialLinks: {
    linkedIn: '',
    instagram: '',
  },
};
